import { validatePhoneSaga } from '../../Lib/redux/sagas/ValidatePhone/validatePhone';
/**
 * Handles the validation of a phone number
 *
 * @param {string} componentId
 * @param {string} countryCode - i.e. US / GB / FR
 * @param {fn} dispatch - function to dispatch an action
 * @param {string} iFrameId
 * @param constraints
 * @param {string|int|undefined} formId
 * @returns undefined
 */
const validatePhone = ({
  value,
  componentId,
  countryCode,
  dispatch,
  iFrameId,
  constraints,
  formId,
}) => {
  dispatch(
    validatePhoneSaga({
      country: countryCode,
      number: value,
      componentId,
      iFrameId,
      constraints,
      formId,
    })
  );
};

export default validatePhone;
